import styled from "styled-components";

const HeadingMenuStyled = styled.div`
padding: 0rem 10rem 0rem 10rem;
margin: 0rem;

.title {
    font-size: 3.44rem;
    color: #161616;
    margin-bottom: 0;
}

.subtitle {
    color: #101010;
    font-size: 1.59rem;
    margin-top: 0;
}
`

export default HeadingMenuStyled;
